<template>
  <b-modal id="bv-modal-create-chapter" size="xl" hide-footer centered>
    <template v-slot:modal-title>
      Create Chapter
    </template>
    <b-form @submit.prevent="createChapter">

      <b-form-group
        id="chapter-title-group"
        label="Chapter Title"
        label-for="chapter-title"
      >
        <b-form-input
          id="chapter-title"
          v-model="createForm.title"
          type="text"
          required
          placeholder="Enter a title"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="chapter-pdf-group"
        label="Upload PDF Research"
        label-for="chapter-pdf"
      >
        <b-form-file
          id="chapter-pdf"
          v-model="createForm.pdf"
          placeholder="Choose a file or drop it here..."
          ref="chapterPdf"
          required
          @change="onFileChange"
        ></b-form-file>
      </b-form-group>

      <template v-if="uploadedPdfName">
        <p>Current file: {{ uploadedPdfName }}</p>
      </template>

      <b-form-group
        id="chapter-image-group"
        label="Image"
        label-for="chapter-image"
      >
        <b-form-file
          id="chapter-image"
          v-model="createForm.image"
          placeholder="Choose an image or drop it here..."
          ref="chapterImage"
          required
          @change="onImageChange"
        ></b-form-file>
      </b-form-group>

      <b-row v-if="uploadedImageUrl" class="mb-3">
        <b-col cols="12" sm="6">
          <img :src="uploadedImageUrl" class="img-fluid" />
        </b-col>
      </b-row>

      <b-row class="row--less-gutters mb-4">

        <b-col cols="3" v-if="monitorCategory === 'consumer'">
          <div class="monitor-tags-group">
            <b-form-group
              id="monitor-tags-consumer-group"
              label="Insights"
              label-for="monitor-tags-consumer"
              v-if="monitorConsumerInsightsOptions.length"
            >
              <b-form-checkbox-group
                id="monitor-tags-consumer"
                v-model="createForm.insights"
                :options="monitorConsumerInsightsOptions"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
        </b-col>

        <b-col cols="3" v-if="monitorCategory === 'market'">
          <div class="monitor-tags-group">
            <b-form-group
              id="monitor-tags-market-group"
              label="Insights"
              label-for="monitor-tags-market"
              v-if="monitorMarketInsightsOptions.length"
            >
              <b-form-checkbox-group
                id="monitor-tags-market"
                v-model="createForm.insights"
                :options="monitorMarketInsightsOptions"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
        </b-col>

        <b-col cols="3">
          <div class="monitor-tags-group">
            <b-form-group
              id="monitor-tags-generations-group"
              label="Generations"
              label-for="monitor-tags-generations"
              v-if="monitorConsumerGenerationsOptions.length"
            >
              <b-form-checkbox-group
                id="monitor-tags-generations"
                v-model="createForm.generations"
                :options="monitorConsumerGenerationsOptions"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
        </b-col>

        <b-col cols="3">
          <div class="monitor-tags-group">
            <b-form-group
              id="monitor-tags-geolocalization-group"
              label="Geolocalization"
              label-for="monitor-tags-geolocalization"
              v-if="monitorGeolocalizationOptions.length"
            >
              <b-form-checkbox-group
                id="monitor-tags-geolocalization"
                v-model="createForm.geolocalizations"
                :options="monitorGeolocalizationOptions"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
        </b-col>

        <b-col cols="3">
          <div class="monitor-tags-group">
            <b-form-group
              id="monitor-tags-gender-group"
              label="Gender"
              label-for="monitor-tags-gender"
              v-if="monitorGenderOptions.length"
            >
              <b-form-checkbox-group
                id="monitor-tags-gender"
                v-model="createForm.genders"
                :options="monitorGenderOptions"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
        </b-col>

      </b-row>

      <b-alert
        :variant="alert.type"
        dismissible
        fade
        :show="alert.show"
        @dismissed="alert.show=0"
        @dismiss-count-down="alertCountDownChanged"
      >
        {{ alert.content }}
      </b-alert>

      <div class="text-right">
        <b-button type="submit" variant="primary"><b-spinner small variant="light" v-if="isLoading"></b-spinner> Create</b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { monitorsDataMixin } from '../mixins/monitorsDataMixin.js';

import {
  MONITOR_CHAPTER_CREATE
} from "@/store/actions.type";

export default {
  name: 'MonitorChapterCreate',
  props: ['chapters'],
  mixins: [monitorsDataMixin],
  data() {
    return {
      isLoading: false,
      tagsCheckboxes: [],
      createForm: {
        title: '',
        pdf: null,
        image: null,
        insights: [],
        generations: [],
        geolocalizations: [],
        genders: []
      },
      uploadedPdfName: '',
      uploadedImageUrl: '',  
      alert: {
        show: 0,
        type: '',
        content: ''
      }
    }
  },
  computed: {
    ...mapGetters(["monitorTags", "monitorCategory", "monitorCurrent"]),
    formTags: function() {
      if(this.monitorCategory == 'consumer') {
        return this.monitorConsumerGenerations
      } else {
        return this.monitorMarketInsights
      }
    }
  },
  methods: {
    alertCountDownChanged(dismissCountDown) {
      this.alert.show = dismissCountDown
    },
    createChapter() {    

      if(!this.validateChapterData()) {
        return
      }

      this.isLoading = true;

      let chapterData = new FormData();
      chapterData.set('monitor', this.monitorCurrent.monitor.id);
      chapterData.set('name', this.createForm.title);
      chapterData.set('pdf_research', this.createForm.pdf);
      if(this.createForm.image) {
        chapterData.set('chapter_picture', this.createForm.image);
      }
      chapterData.set('order', this.monitorCurrent.chapters.length + 1);

      let i = 0;
      for (i = 0; i < this.createForm.insights.length; i++) {
        chapterData.append('insights', this.createForm.insights[i]);
      }
      for (i = 0; i < this.createForm.generations.length; i++) {
        chapterData.append('generations', this.createForm.generations[i]);
      }
      for (i = 0; i < this.createForm.geolocalizations.length; i++) {
        chapterData.append('geolocalizations', this.createForm.geolocalizations[i]);
      }
      for (i = 0; i < this.createForm.genders.length; i++) {
        chapterData.append('genders', this.createForm.genders[i]);
      }

      let payload = {
        monitorId: this.monitorCurrent.monitor.id,
        chapterData: chapterData
      }

      this.$store.dispatch(MONITOR_CHAPTER_CREATE, payload).then(() => {
        this.$bvModal.hide('bv-modal-create-chapter');
        this.$bvToast.toast(`Chapter ${this.createForm.title} has been created successfully`, {
          title: 'Chapter created',
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 4000,
          variant: 'primary'
        });
        this.resetForm();
        this.isLoading = false;
        this.$emit('chapterCreated');
      });
    },
    validateChapterData() {
      if(this.createForm.geolocalization == 0 || this.createForm.gender == 0) {
        this.alert.show = 3;
        this.alert.type = 'danger';
        this.alert.content = 'You must select at least one generation, insight, geolocalization and gender';
        this.isLoading = false;
        return false
      } else {
        return true
      }
    },
    resetForm() {
      this.createForm.title = '';
      this.createForm.pdf = null;
      this.createForm.image = null;
      this.createForm.insights = [];
      this.createForm.generations = [];
      this.createForm.geolocalizations = [];
      this.createForm.genders = [];
      this.uploadedPdfName = '';
      this.uploadedImageUrl = '';
    },
    onFileChange(e) {
      this.uploadedPdfName = e.target.files[0].name;
    },
    onImageChange(e) {
      const image = e.target.files[0];
      this.uploadedImageUrl = URL.createObjectURL(image);
    }
  },
  mounted() {

  }
}
</script>